import React from "react";
import { connect } from "react-redux";
import Dropzone from "react-dropzone";
import PropTypes from "prop-types";
import { filesUpload } from "../actions/upload.js";
import T from "i18n-react";
const mapDispatchToProps = () => dispatch => ({
	filesUpload: (files, url) => dispatch(filesUpload(files, url))
});
export class FileUpload extends React.Component {
	constructor(props, context) {
		super(props);
	}

	onDrop(files, rejected) {
		this.props
			.filesUpload(files, "/forms/" + this.context.formId + "/files")
			.then(resp => {
				if (resp.length > 0) {
					var fileId = resp[0].headers.location.split("/").pop();
					this.props.setFileId(fileId);
				}
			});
	}

	render() {
		return (
			<Dropzone
				className="row"
				onDrop={this.onDrop.bind(this)}
			>
				<button className="button" type="button">
					{T.translate("form.upload-file")}
				</button>
				<p className="question__upload-restriction">
					{T.translate("form.upload-restriction")}
				</p>
			</Dropzone>
		);
	}
}

export default connect(null, mapDispatchToProps)(FileUpload);
FileUpload.PropTypes = {
	setFileId: PropTypes.func.isRequired
};

FileUpload.contextTypes = {
	formId: PropTypes.string.isRequired
};
